<template>
    <div class="barrage-main" ref="barrageContainer"></div>
</template>

<script>
export default {
    props: {
        // 弹幕源数组
        barrageData: {
            type: Array,
            default: function() {
                return []
            },
        },
        // 行数
        rowCount: {
            type: Number,
            default: 6,
        },
    },
    data() {
        return {
            // 弹幕数组
            list: [],
            rowCurrent: [],
            domPool: [],
        }
    },
    mounted() {
        this.timer = null
        this.hasPosition = []
        
        // 缓存容器宽度
        const barrageContainer = this.$refs.barrageContainer
        this.barMainWidth = barrageContainer.clientWidth
        this.itemHighet = barrageContainer.clientHeight / this.rowCount
        this.init()
        // 开始播放弹幕
        this.play()
    },
    watch: {
        barrageData(list) {
            this.list = list
            if (!this.timer) {
                this.play()
            }
        },
    },
    methods: {
        randomNum(a, b) {
            return Math.floor(Math.random() * (b - a) + a)
        },
        createEl() {
            const dom = document.createElement('div')
            const transform = `translate3d(${this.barMainWidth}px, 0, 0)`
            const position = this.getPosition()
            dom.className = 'barrage-item'
            dom.style.transform = transform
            let divTop = position * this.itemHighet + this.randomNum(-10, 10)
            if (divTop < 0) {
                divTop  = 0
            }
            dom.style.top = divTop + 'px'
            dom.addEventListener('animationend', () => {
                this.rowCurrent[position] -= 1
                this.$refs.barrageContainer.removeChild(dom)
            })
            // 生成节点后 设置当前弹道 数量
            this.rowCurrent[position] += 1
            return dom
        },
        init() {
            for (let index = 0; index < this.rowCount; index++) {
                this.rowCurrent[index] = 0
            }
        },
        getPosition() {
            let minBarrageNum = this.rowCurrent[0]
            let minBarrageIndex = 0
            for (let index = 0; index < this.rowCurrent.length; index++) {
                const item = this.rowCurrent[index]
                if (item < minBarrageNum) {
                    minBarrageNum = item
                    minBarrageIndex = index
                }
            }
            return minBarrageIndex
        },
        createBarrage(item) {
            // 生成弹幕
            const dom = this.createEl()
            this.$refs.barrageContainer.appendChild(dom)
            dom.innerText = item.content
            dom.className = 'barrage-item'
            dom.style.animation = `barrage-run ${this.randomNum(7000, 10000)}ms linear`
        },
        // 暂停弹幕
        pause() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        // 播放弹幕
        play() {
            // 随机 500ms ~ 1000ms
            const timeNum = this.randomNum(500, 1000)
            this.timer = setInterval(() => {
                if (this.list.length > 0) {
                    const barrage = this.list.shift()
                    this.createBarrage(barrage)
                } else {
                    this.pause()
                }
            }, timeNum)
        },
    },
    components: {},
}
</script>
<style lang="scss">
.barrage-main {
    position: absolute;
    width: 100%;
    overflow: hidden;
    height: 100%;
    .barrage-item {
        position: absolute;
        z-index: 1;
        user-select: none; // 禁用选择文字
        white-space: pre;
        will-change: transform;
        font-size: 14px;
        color: #fff;
        padding: 8px 15px;
        background: rgba(1, 1, 1, 0.6);
        line-height: 1em;
        border-radius: 30px;
    }
}
@keyframes barrage-run {
    100% {
        transform: translateX(-100%);
    }
}

.ani-pause {
    & div {
        animation-play-state: paused !important;
    }
}
.ani-running {
    & div {
        animation-play-state: running !important;
    }
}
</style>
